import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function Navigation({
  showButton = true
}: {
  showButton?: boolean;
}) {
  const scrollToContact = () => {
    const footerForm = document.getElementById('footer-form');
    if (footerForm) {
      footerForm.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.3
  }} className="sticky top-0 z-50 bg-[#0A2540]/95 backdrop-blur-md border-b border-white/10" data-id="element-97">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-98">
        <div className="flex items-center justify-between h-20 md:h-24" data-id="element-99">
          {/* Logo */}
          <div className="flex items-center" data-id="element-100">
            <a href="#" className="flex items-center group" data-id="element-101">
              <img src="https://cdn.magicpatterns.com/uploads/m9sqFFb3nhqtLypfuq3qEr/Dealers-Choice-Solutions-Logo-(Dark-Blue-BG).png" alt="DealersChoice Solutions" className="h-12 md:h-16 w-auto transition-opacity group-hover:opacity-80" data-id="element-102" />
            </a>
          </div>

          {/* Contact Actions */}
          {showButton && <div className="flex items-center gap-4" data-id="element-103">
              <a href="tel:5188389060" className="flex items-center gap-2 text-white hover:text-[#D4AF37] transition-colors font-semibold text-sm md:text-base hidden sm:flex underline underline-offset-4 decoration-white/40 hover:decoration-[#D4AF37]" data-id="element-104">
                <PhoneIcon className="w-4 h-4" data-id="element-105" />
                (518) 838-9060
              </a>
              <Button variant="primary" size="md" onClick={scrollToContact} className="shadow-lg" data-id="element-106">
                Book A Free Strategy Call
              </Button>
            </div>}
        </div>
      </div>
    </motion.nav>;
}